import {Shape} from "react-konva";
import type {MapRegistration} from "@/dungeons/model/DungeonGeometry.ts";
import {gridLineIndexRange} from "./GridLineRange.ts";

export default function DungeonGridShape({width, height, registration, zoom,
    color = "rgba(65, 210, 255, 0.55)", opacity = 1}: {
    width: number;
    height: number;
    registration: MapRegistration;
    zoom: number;
    color?: string;
    opacity?: number;
}) {
    const spacing = registration.pixelsPerCell;
    if (!registration.calibrated || !Number.isFinite(spacing) || spacing <= 0
        || !Number.isFinite(zoom) || zoom <= 0 || spacing * zoom < 5) return null;
    const columns = gridLineIndexRange(width, registration.gridOffsetX, spacing);
    const rows = gridLineIndexRange(height, registration.gridOffsetY, spacing);
    return <Shape listening={false} stroke={color} opacity={opacity} strokeWidth={1 / zoom}
                  sceneFunc={(context, shape) => {
                      context.beginPath();
                      for (let column = columns.first; column <= columns.last; column++) {
                          const x = registration.gridOffsetX + column * spacing;
                          context.moveTo(x, 0);
                          context.lineTo(x, height);
                      }
                      for (let row = rows.first; row <= rows.last; row++) {
                          const y = registration.gridOffsetY + row * spacing;
                          context.moveTo(0, y);
                          context.lineTo(width, y);
                      }
                      context.strokeShape(shape);
                  }}/>
}
